"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgArrowDown = function SvgArrowDown(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "theme", "title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2202 21.6385L6.3211 12.8712C6.10703 12.6603 6 12.4042 6 12.1029C6 11.8017 6.10703 11.5456 6.3211 11.3347L7.33027 10.3404C7.54434 10.1295 7.80428 10.0166 8.11009 10.0015C8.4159 9.98644 8.67584 10.0844 8.88991 10.2953L16 17.3L23.1101 10.2953C23.3242 10.0844 23.5841 9.98644 23.8899 10.0015C24.1957 10.0166 24.4557 10.1295 24.6697 10.3404L25.6789 11.3347C25.893 11.5456 26 11.8017 26 12.1029C26 12.4042 25.893 12.6603 25.6789 12.8712L16.7798 21.6385C16.5657 21.8795 16.3058 22 16 22C15.6942 22 15.4343 21.8795 15.2202 21.6385Z",
      fill: fill || theme.colors.primary.main
    })]
  }));
};

var _default = SvgArrowDown;
exports["default"] = _default;